import { render, staticRenderFns } from "./CheckboxLabel.vue?vue&type=template&id=1c3f14ba&scoped=true"
import script from "./CheckboxLabel.vue?vue&type=script&lang=js"
export * from "./CheckboxLabel.vue?vue&type=script&lang=js"
import style0 from "./CheckboxLabel.vue?vue&type=style&index=0&id=1c3f14ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f14ba",
  null
  
)

export default component.exports